import { render } from "./Profile.vue?vue&type=template&id=77b6c36d&scoped=true&ts=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=77b6c36d&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b6c36d"]])

export default __exports__